import React from 'react';
import { Users, Clock3, MapPin, ArrowRight } from 'lucide-react';

const classes = [
  {
    id: 1,
    title: 'Weekend Physics Group Class',
    level: 'A/L Local',
    location: 'Colombo / Online',
    time: 'Sat 8:00 AM - 11:00 AM',
  },
  {
    id: 2,
    title: 'Cambridge Chemistry Revision Batch',
    level: 'AS/A-Level',
    location: 'Kandy / Online',
    time: 'Sun 2:00 PM - 5:00 PM',
  },
];

const PrivateClassesPage = () => {
  return (
    <div className="max-w-7xl mx-auto px-6 py-12">
      <header className="mb-10">
        <h1 className="text-4xl font-bold text-accentBlue mb-2">Private Classes</h1>
        <p className="text-gray-400">Find small-group and private sessions by syllabus and level.</p>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {classes.map((item) => (
          <div key={item.id} className="bg-white/5 border border-white/10 rounded-3xl p-6 hover:border-accentBlue/50 transition">
            <div className="flex items-center gap-3 mb-4 text-accentBlue">
              <Users size={18} />
              <span className="text-xs font-bold uppercase tracking-wide">Class Listing</span>
            </div>

            <h3 className="text-xl font-bold mb-2">{item.title}</h3>
            <p className="text-sm text-gray-400 mb-4">{item.level}</p>

            <div className="space-y-2 text-sm text-gray-300 mb-6">
              <div className="flex items-center gap-2">
                <MapPin size={15} className="text-accentBlue" />
                {item.location}
              </div>
              <div className="flex items-center gap-2">
                <Clock3 size={15} className="text-accentBlue" />
                {item.time}
              </div>
            </div>

            <button className="w-full py-3 rounded-xl border border-white/10 hover:border-accentBlue/50 transition text-sm font-semibold flex items-center justify-center gap-2">
              View Details <ArrowRight size={14} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PrivateClassesPage;
